import React, { useEffect } from 'react';
import { Container, Typography, Button, Box } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'https://watchpassion.vercel.app/api';

export default function CheckoutSuccessPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const paymentIntent = params.get('payment_intent');
  const itemId = params.get('itemId');

  useEffect(() => {
    if (!paymentIntent) return;
    // Order is created via webhook; just show success
  }, [paymentIntent]);

  return (
    <Container maxWidth="sm" sx={{ pt: 10, textAlign: 'center' }}>
      <CheckCircleOutlineIcon sx={{ fontSize: 80, color: 'success.main', mb: 2 }} />
      <Typography variant="h4" fontWeight="bold" gutterBottom>Pagamento completato!</Typography>
      <Typography color="text.secondary" sx={{ mb: 4 }}>
        Grazie per il tuo acquisto. Riceverai una conferma via email a breve.
      </Typography>
      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
        <Button variant="contained" onClick={() => navigate('/mercato')}>
          Torna al marketplace
        </Button>
        <Button variant="outlined" onClick={() => navigate('/i-miei-ordini')}>
          I miei ordini
        </Button>
      </Box>
    </Container>
  );
}
